import React, { useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import TransaksiService from '../../../services/transaksi/TransaksiService'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalProsesRollback = ({ showRollback, handleCloseRollback, dataDisposisi, datappm, reloadList, isCetakUlang }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    const [dataHc, setDataHc] = useState(null)

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                let jsonMutuPK = {
                    nomorAju: datappm.nomorAju,
                    noProses: dataDisposisi.noTugas
                }
                const resHc = await transaksiService.getHcMutuById(jsonMutuPK)
                setDataHc(resHc.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [transaksiService, datappm, dataDisposisi])

    const [valueAlasanRollback, setValueAlasanRollback] = useState(null)
    const onChangeAlasan = e => {
        setValueAlasanRollback(e.target.value)
    }

    const [loadingCetakUlang, setLoadingCetakUlang] = useState(false)
    const [showConfirmCetakUlang, setShowConfirmCetakUlang] = useState(false)
    const handleCloseConfirmCetakUlang = () => {
        setShowConfirmCetakUlang(false)
    }
    const handleConfirmCetakUlang = () => {
        setShowConfirmCetakUlang(true)
    }
    const [showCetakUlangSuccess, setShowCetakUlangSuccess] = useState(false)
    const [showCetakUlangFailed, setShowCetakUlangFailed] = useState(false)

    const [kelengkapan, setKelengkapan] = useState({})
    const checkKelengkapan = () => {
        const checkKelengkapan = {}
        if (!valueAlasanRollback) checkKelengkapan.alasanRollback = 'Alasan Wajib Diisi'

        setKelengkapan(checkKelengkapan)
        return Object.keys(checkKelengkapan).length === 0
    }

    const handleClickCetakUlangProses = async () => {
        setLoadingCetakUlang(true)
        if (checkKelengkapan()) {
            try {
                let dataPpm = {
                    ...datappm,
                    status: '028',
                    lastUpdated: new Date(),
                    userUpdated: localStorage.getItem('username').substring(0, 5)
                }
                const _resCetakUlang = await transaksiService.addPpm(dataPpm)
                if (_resCetakUlang.data.kode === '200') {
                    let dataDispo = { ...dataDisposisi, noTugas: null, tglTugas: null }
                    await transaksiService.addPenugasan(dataDispo)

                    let dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '028',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await transaksiService.addPpmStatus(JSON.stringify(dataStatus))

                    let jsonRollback = {
                        nomorAju: datappm.nomorAju,
                        noHcMutu: dataHc.noHcMutu,
                        noSeriMutuBefore: dataHc.noSeriMutu,
                        idDisposisiBefore: dataDisposisi.idDisposisi,
                        alasanRollback: valueAlasanRollback,
                        createdBy: localStorage.getItem('username'),
                        createdDate: new Date()
                    }
                    const _resRollback = await transaksiService.addHistoryRollback(jsonRollback)
                    if (_resRollback.data.kode === '200') {
                        setShowConfirmBackDraft(false)
                        setShowBackDraftSuccess(true)
                    } else {
                        setShowConfirmBackDraft(false)
                        setShowBackDraftFailed(true)
                    }
                } else {
                    setShowConfirmCetakUlang(false)
                    setShowCetakUlangFailed(true)
                }
            } catch (error) {
                setShowConfirmCetakUlang(false)
                setShowCetakUlangFailed(true)
            }
        } else {
            setShowConfirmCetakUlang(false)
        }
        setLoadingCetakUlang(false)
    }

    const handleClickCetakUlangSuccess = () => {
        setShowCetakUlangSuccess(false)
        reloadList(datappm.nomorAju, 0, 10)
    }

    const handleClickCetakUlangFailed = () => {
        setShowCetakUlangFailed(false)
        reloadList(datappm.nomorAju, 0, 10)
    }

    const [loadingDraft, setLoadingDraft] = useState(false)
    const [showConfirmBackDraft, setShowConfirmBackDraft] = useState(false)
    const handleCloseConfirmBackDraft = () => {
        setShowConfirmBackDraft(false)
    }
    const handleConfirmBackDraft = () => {
        setShowConfirmBackDraft(true)
    }
    const [showBackDraftSuccess, setShowBackDraftSuccess] = useState(false)
    const [showBackDraftFailed, setShowBackDraftFailed] = useState(false)

    const handleClickBackDraftProses = async () => {
        setLoadingDraft(true)
        if (checkKelengkapan()) {
            try {
                let dataPpm = {
                    ...datappm,
                    status: '027',
                    synch: datappm.synch !== '0' ? '2' : '0',
                    lastUpdated: new Date(),
                    userUpdated: localStorage.getItem('username').substring(0, 5)
                }
                const _resBackDraft = await transaksiService.addPpm(dataPpm)
                if (_resBackDraft.data.kode === '200') {
                    if (dataDisposisi.idDisposisi === 9) {
                        const _resPenugasanPnbpFinal = await transaksiService.listPenugasanPnbpFinal(datappm.nomorAju)
                        _resPenugasanPnbpFinal.data.data.map(async (penugasan) => {
                            await transaksiService.deletePenugasanById(penugasan.idProses)
                        })
                    }

                    let dataStatus = {
                        nomorAju: datappm.nomorAju,
                        kodeStatus: '027',
                        waktuStatus: new Date(),
                        createdBy: localStorage.getItem('username')
                    }
                    await transaksiService.addPpmStatus(JSON.stringify(dataStatus))

                    let jsonRollback = {
                        nomorAju: datappm.nomorAju,
                        noHcMutu: dataHc.noHcMutu,
                        noSeriMutuBefore: dataHc.noSeriMutu,
                        idDisposisiBefore: dataDisposisi.idDisposisi,
                        alasanRollback: valueAlasanRollback,
                        createdBy: localStorage.getItem('username'),
                        createdDate: new Date()
                    }
                    const _resRollback = await transaksiService.addHistoryRollback(jsonRollback)
                    if (_resRollback.data.kode === '200') {
                        setShowConfirmBackDraft(false)
                        setShowBackDraftSuccess(true)
                    } else {
                        setShowConfirmBackDraft(false)
                        setShowBackDraftFailed(true)
                    }

                } else {
                    setShowConfirmBackDraft(false)
                    setShowBackDraftFailed(true)
                }
            } catch (error) {
                setShowConfirmBackDraft(false)
                setShowBackDraftFailed(true)
            }
        } else {
            setShowConfirmBackDraft(false)
        }
        setLoadingDraft(false)
    }

    const handleClickBackDraftSuccess = () => {
        setShowBackDraftSuccess(false)
        reloadList(datappm.nomorAju, 0, 10)
    }

    const handleClickBackDraftFailed = () => {
        setShowBackDraftFailed(false)
        reloadList(datappm.nomorAju, 0, 10)
    }

    return (
        <>
            <Modal
                show={showRollback}
                onHide={handleCloseRollback}
                backdrop='static'
                scrollable={true}
                size='lg'
                centered
            >
                <Modal.Header closeButton><h6>Rollback Permohonan</h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Aju</label>
                        <div className="col-sm-6">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_aju" defaultValue={datappm.nomorAju} readOnly />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Alasan Dikembalikan / Cetak Ulang<span className='text-danger'>*</span></label>
                        <div className="col-sm-6">
                            <textarea rows={5} className="col-sm-12 form-control-sm" name="alasanRollback" value={valueAlasanRollback} onChange={onChangeAlasan} />
                        </div>
                        {kelengkapan.alasanRollback && <div className="text-danger">{kelengkapan.alasanRollback}</div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {
                        isCetakUlang === 'Y' && <Button variant="primary" size="sm" onClick={() => handleConfirmCetakUlang()}>Proses Cetak Ulang</Button>
                    }
                    {
                        isCetakUlang === 'T' && <Button variant="primary" size="sm" onClick={() => handleConfirmBackDraft()}>Proses</Button>
                    }
                    {' '}<Button variant="secondary" size="sm" onClick={handleCloseRollback}>Close</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmBackDraft &&
                <SweetAlert
                    title="Kembalikan Dokumen Permohonan ke Draft Persetujuan Pengguna Jasa?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingDraft ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    reverseButtons={true}
                    onConfirm={handleClickBackDraftProses}
                    onCancel={handleCloseConfirmBackDraft}
                    focusCancelBtn
                    btnSize="sm"
                >
                    {loadingDraft && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Update data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showBackDraftSuccess &&
                <SweetAlert
                    success
                    title="Update Data Berhasil"
                    onConfirm={handleClickBackDraftSuccess}
                    btnSize="sm"
                />
            }
            {
                showBackDraftFailed &&
                <SweetAlert
                    danger
                    title="Update Data Gagal"
                    onConfirm={handleClickBackDraftFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showConfirmCetakUlang &&
                <SweetAlert
                    title="Cetak Ulang SMKHP?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingCetakUlang ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    reverseButtons={true}
                    onConfirm={handleClickCetakUlangProses}
                    onCancel={handleCloseConfirmCetakUlang}
                    focusCancelBtn
                    btnSize="sm"
                >
                    {loadingCetakUlang && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Update data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showCetakUlangSuccess &&
                <SweetAlert
                    success
                    title="Update Data Berhasil"
                    onConfirm={handleClickCetakUlangSuccess}
                    btnSize="sm"
                />
            }
            {
                showCetakUlangFailed &&
                <SweetAlert
                    danger
                    title="Update Data Gagal"
                    onConfirm={handleClickCetakUlangFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalProsesRollback